module.exports = __webpack_public_path__ + "static/media/IMG-20221007-WA0000.98797b24.jpg";